import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-950">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-300 dark:text-gray-700">404</h1>
        <h2 className="mt-4 text-2xl font-bold">Página não encontrada</h2>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          A página que você procura não existe ou foi movida.
        </p>
        <Link
          to="/"
          className="mt-8 inline-block rounded-lg bg-accent-600 px-6 py-3 font-medium text-white hover:bg-accent-700"
        >
          Voltar para Home
        </Link>
      </div>
    </div>
  );
}